module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kasi_m2.62aba6022f93d5708ea2ce260a069db0.png";